import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const MessageTemplateBuilder = ({ templates, onTemplateCreate }) => {
  const [showBuilder, setShowBuilder] = useState(false);
  const [newTemplate, setNewTemplate] = useState({
    name: '',
    type: 'whatsapp',
    subject: '',
    content: '',
    category: 'general',
    language: 'es'
  });

  const handleCreate = () => {
    if (newTemplate?.name && newTemplate?.content) {
      // Extract variables from content ({{variable}})
      const variables = [...newTemplate?.content?.matchAll(/\{\{(\w+)\}\}/g)]?.map(match => match?.[1]);
      
      onTemplateCreate({
        ...newTemplate,
        variables: variables
      });
      
      setNewTemplate({
        name: '',
        type: 'whatsapp',
        subject: '',
        content: '',
        category: 'general',
        language: 'es'
      });
      setShowBuilder(false);
    }
  };

  const insertVariable = (variable) => {
    setNewTemplate({
      ...newTemplate,
      content: newTemplate?.content + `{{${variable}}}`
    });
  };

  const commonVariables = [
    'nombre', 'email', 'telefono', 'proyecto', 'fecha', 'hora',
    'direccion', 'asesor', 'precio', 'estado'
  ];

  return (
    <div className="bg-card rounded-xl p-4 sm:p-6 border border-border sticky top-24">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center">
          <Icon name="MessageSquare" size={24} className="mr-3 text-primary" />
          <h2 className="text-lg font-semibold text-foreground">Quick Template</h2>
        </div>
        <button
          onClick={() => setShowBuilder(!showBuilder)}
          className="text-primary hover:text-primary/80 transition-colors"
        >
          <Icon name={showBuilder ? 'ChevronUp' : 'ChevronDown'} size={20} />
        </button>
      </div>

      {showBuilder ? (
        <div className="space-y-4">
          <div>
            <label className="text-sm font-medium text-foreground mb-2 block">
              Template Name
            </label>
            <Input
              value={newTemplate?.name}
              onChange={(e) => setNewTemplate({ ...newTemplate, name: e?.target?.value })}
              placeholder="e.g., Welcome Message"
            />
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="text-sm font-medium text-foreground mb-2 block">
                Type
              </label>
              <select
                value={newTemplate?.type}
                onChange={(e) => setNewTemplate({ ...newTemplate, type: e?.target?.value })}
                className="w-full px-3 py-2 bg-background border border-border rounded-lg text-foreground focus:ring-2 focus:ring-primary"
              >
                <option value="whatsapp">WhatsApp</option>
                <option value="email">Email</option>
                <option value="sms">SMS</option>
                <option value="in_app">In-App</option>
              </select>
            </div>
            <div>
              <label className="text-sm font-medium text-foreground mb-2 block">
                Category
              </label>
              <select
                value={newTemplate?.category}
                onChange={(e) => setNewTemplate({ ...newTemplate, category: e?.target?.value })}
                className="w-full px-3 py-2 bg-background border border-border rounded-lg text-foreground focus:ring-2 focus:ring-primary"
              >
                <option value="general">General</option>
                <option value="lead_nurturing">Lead Nurturing</option>
                <option value="appointment">Appointment</option>
                <option value="commission">Commission</option>
                <option value="marketing">Marketing</option>
              </select>
            </div>
          </div>

          {newTemplate?.type === 'email' && (
            <div>
              <label className="text-sm font-medium text-foreground mb-2 block">
                Subject
              </label>
              <Input
                value={newTemplate?.subject}
                onChange={(e) => setNewTemplate({ ...newTemplate, subject: e?.target?.value })}
                placeholder="Email subject"
              />
            </div>
          )}

          <div>
            <label className="text-sm font-medium text-foreground mb-2 block">
              Message Content
            </label>
            <textarea
              value={newTemplate?.content}
              onChange={(e) => setNewTemplate({ ...newTemplate, content: e?.target?.value })}
              placeholder="Type your message... Use {{variable}} for dynamic content"
              rows={6}
              className="w-full px-3 py-2 bg-background border border-border rounded-lg text-foreground focus:ring-2 focus:ring-primary resize-none"
            />
          </div>

          <div>
            <label className="text-xs font-medium text-muted-foreground mb-2 block">
              Insert Variables
            </label>
            <div className="flex flex-wrap gap-2">
              {commonVariables?.map((variable) => (
                <button
                  key={variable}
                  onClick={() => insertVariable(variable)}
                  className="px-2 py-1 text-xs bg-primary/10 text-primary rounded hover:bg-primary/20 transition-colors"
                >
                  {variable}
                </button>
              ))}
            </div>
          </div>

          <div className="flex gap-2">
            <Button onClick={handleCreate} fullWidth iconName="Save">
              Create
            </Button>
            <Button
              variant="outline"
              onClick={() => setShowBuilder(false)}
              fullWidth
            >
              Cancel
            </Button>
          </div>
        </div>
      ) : (
        <div>
          <p className="text-sm text-muted-foreground mb-4">
            Create message templates for WhatsApp, Email, and SMS communications
          </p>
          <Button
            fullWidth
            iconName="Plus"
            onClick={() => setShowBuilder(true)}
          >
            New Template
          </Button>

          {templates?.length > 0 && (
            <div className="mt-4 pt-4 border-t border-border">
              <p className="text-xs font-medium text-muted-foreground mb-2">
                Recent Templates
              </p>
              <div className="space-y-2">
                {templates?.slice(0, 3)?.map((template) => (
                  <div
                    key={template?.id}
                    className="p-2 bg-muted/20 rounded text-xs"
                  >
                    <p className="font-medium text-foreground truncate">{template?.name}</p>
                    <p className="text-muted-foreground capitalize">{template?.type}</p>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MessageTemplateBuilder;